export const USER = "User";
export const NEWS = "News";
export const TEAM = "Team";
export const SELF = "Self";
export const GUN = "Gun";
export const DETAIL = "Detail";
export const SUMMARY = "Summary";